<template>
  <div v-if="isVisible">
    <div class="row">
      <h4 class="col-12">Firmantes</h4>
      <LmTreeSelect
        class="col-6"
        v-model="signers"
        :pathToGetOptions="optionsPath"
        :label="label"
        multiple
      />
      <div class="col-6">
        <draggable
          v-if="signers"
          tag="b-list-group"
          v-model="signers"
          @start="drag=true"
          @end="drag=false"
          animation="150"
        >
          <b-list-group-item
            v-for="(item, index) in signers"
            :key="index"
            class="d-flex justify-content-between"
            >
            <font-awesome-icon class="bar mr-2" icon="bars" />
            {{ item.name }}
            <div class="d-flex justify-content-end align-items-center">
              <font-awesome-icon class="mr-2" icon="fingerprint"/>
              <b-badge variant="primary file-size">{{ index + 1 }}</b-badge>
            </div>
          </b-list-group-item>
        </draggable>
        <div v-else>
          <p class="text-center">
            Todavía no se han seleccionado firmantes para este documento.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'

import draggable from 'vuedraggable'

import lmInputMixin from '@/mixins/lmInputMixin.js'

export default {
  mixins: [lmInputMixin],
  components: {
    LmTreeSelect,
    draggable
  },
  props: {
    optionsPath: {
      type: String,
      default: '/users/all'
    }
  },
  data () {
    return {
    }
  },
  computed: {
    signers: {
      get () {
        return this.value || null
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
